<template>
  <div class="content">
    <div class="banner">
      <img src="@/assets/banner1-home.jpg" class="imgs" alt="" />
      <!-- <img src="@/assets/20211021-201940.jpg" class="imgs" alt="" /> -->

      <div class="banner-content" style="">
        <p :style="{ fontSize: (china ? '32px' : '24px') }" style="word-spacing: 5px;">
          {{ lang.homePageTitle }}
        </p>
        <p>
          <span
            style="display: inline-block; width: 30px; height: 2px; background: white; margin-top: 0px; margin-bottom: 12px; border-radius: 2px">
          </span>
        </p>
        <p :style="{ fontSize: (china ? '18px' : '17px') }">
          {{ lang.homePageFirst }}
        </p>
        <p :style="{ fontSize: (china ? '18px' : '17px') }" style="margin-top: 5px;">
          {{ lang.homePageSecond }}
        </p>
        <p>
          <Button s size="small" type="info" @click="$routeChange('about')"
            style="font-size: 14px; width: 106px; height: 40px;">
            {{ lang.aboutUs }}
          </Button>
        </p>
      </div>
    </div>
    <div class="artical">
      <div class="paragraph">
        <div class="artical-title">{{ lang.aboutUs }}</div>
        <div class="artical-content">
          <p @click="$routeChange('about')">
            <img v-if="china" src="@/assets/home/aboutus-img.jpg" width="100%" alt="" />
            <img v-else src="@/assets/en/aboutus-img.jpg" width="100%" alt="" />
            <!-- <span :style="{background: aboutImg}"></span> -->
          </p>
        </div>
      </div>
      <div class="paragraph">
        <div class="artical-title">{{ lang.joinUs }}</div>
        <div class="artical-content">
          <p>
            <!-- <img v-if="china" src="@/assets/home/joinus-img.jpg" width="100%" alt="" /> -->
            <!-- <img v-else src="@/assets/en/joinus-img.jpg" width="100%" alt="" /> -->
            <img src="@/assets/home/joinus-img.jpg" width="100%" alt="" />
            <span>
              <a v-bind:href="joinUsSocialLink" target="_blank">
                {{ lang.homePageJoin_1 }}<i class="iconfont iconLine23"></i>
              </a>
              <a v-bind:href="joinUsCampusLink" target="_blank">
                {{ lang.homePageJoin_2 }}<i class="iconfont iconLine23"></i>
              </a>
            </span>
          </p>
        </div>
      </div>
      <div class="paragraph">
        <div class="artical-title">{{ lang.contactUs }}</div>
        <div class="artical-content">
          <p @click="$routeChange('connection')">
            <img v-if="china" src="@/assets/home/contact-img.jpg" width="100%" alt="" />
            <img v-else src="@/assets/en/contact-img.jpg" width="100%" alt="" />
          </p>
        </div>
      </div>
    </div>
    <page-footer></page-footer>
  </div>
</template>
<script>
import { Button } from "vant"
import mapStore from '@/mixins/mapStore'
export default {
  components: {
    Button,
  },
  mixins: [
    mapStore('', {
      getters: ['lang', 'china']
    })
  ],
  data() {
    return {
      joinUsSocialLink: process.env.VUE_APP_MOKA_SOCIAL_LINK || '/join',
      joinUsCampusLink: process.env.VUE_APP_MOKA_CAMPUS_LINK || '/join'
    }
  }
}
</script>
<style lang="less" scoped>
.content {
  padding-top: 52px;
}

.banner {
  width: 100%;
  height: 420px;
  position: relative;

  .imgs {
    width: 100%;
    height: 420px;
    position: absolute;
    top: 0;
    left: 0;
    object-fit: cover;
  }
}

.banner-content {
  color: white;
  position: relative;
  top: 50%;
  transform: translateY(-50%);
  text-align: center;

  p:nth-of-type(1) {
    font-size: 32px;
    font-weight: bold;
  }

  p:nth-of-type(2) {
    font-size: 32px;
    font-weight: bold;
  }

  p:nth-of-type(3),
  p:nth-of-type(4) {
    font-size: 18px;
  }

  p:nth-of-type(5) {
    margin-top: 30px;
  }
}

.artical {
  background: white;
  padding: 10px 15px 30px;
}

.paragraph {
  margin-top: 20px;

  &::after {
    content: "";
    display: block;
    visibility: hidden;
    clear: both;
  }

  .artical-title {
    font-size: 18px;
    font-weight: 500;
  }

  .artical-title::after {
    content: "/";
    display: inline-block;
    font-weight: 500;
    font-size: 18px;
    margin-left: 10px;
  }

  .artical-content {
    p {
      margin-top: 12px;
      position: relative;

      span {
        display: block;
        position: absolute;
        left: 50%;
        top: 50%;
        margin-top: -56px;
        margin-left: -59px;
      }

      a {
        display: block;
        font-size: 14px;
        text-align: center;
        color: #fff;
        height: 38px;
        line-height: 38px;
        border: 1px solid #fff;
        box-sizing: border-box;
        padding-left: 20px;
        padding-right: 15px;
        margin: 10px 0;

        i {
          line-height: 38px;
          font-size: 12px;
          color: #fff;
          margin-left: 2px;
        }
      }
    }
  }

  .title {
    font-size: 15px;
    font-weight: bold;
    margin-bottom: 10px;
  }

  .context {
    margin-top: 5px;
    color: #76808e;
    font-size: 15px;
  }
}
</style>